import React from "react";
import { Content } from "./styles";



function WellcomeBox({user}) {
	function renderName(name) {
		if (name) {
			const cleanedName = name.replace(/[0-9./-]/g, '').trimStart();
			return `    ${cleanedName.split(" ").slice(0, 3).join(" ")}`;
		}
		return '   ';
	}

	return (
		<Content>
			Bem-vindo,
			<b className="content-name notranslate">{renderName(user?.dados?.nome)}</b>
			<div className="content-img" />
		</Content>
	);
}

export default WellcomeBox;
